import { RootState } from '../store.model';

export const getNetworkIsOnline = (state: RootState) =>
  state.network.networkState === 'online';
